import { WIDGET } from "@model/components/componentMeta.model";
// import color from "@helpers/color.helper";
const createWidgetMap = () => {
  const randomkey = `${WIDGET.prefixKey}${Math.random().toString(36).substring(4)}`
  const key = `${WIDGET.prefixKey}${randomkey.substring(randomkey.length - 4, randomkey.length)}`
  return {
    key,
    object: {
      [key]: {
        id: key,
        type: `SYSTEM_WIDGET_MAP`,
        properties: {
          isSystem: true,
          requireWidth: 555,
          isShowModeControl: true,
          isShowZoomControl: true,
          isShowStreetViewControl: true,
          isShowDirectionLink: true,
          allowDragging: true,
          isMultipleBranch: false
        },
        style: {
          alignX: "center",
          marginTop: 10,
          marginBottom: 10,
          width: "auto",
          height: 300,
          colorTheme: null,
        },
        styleMobile: {
          alignX: "center",
          marginTop: 10,
          marginBottom: 10,
          width: "auto",
          height: 300,
          colorTheme: null,
        },
        data: {
          branchMultiple: [
            {
              branchID: 1,
              logo: "",
              logoID: "",
              description: "Description detail",
              name: "Default Location",
              longitude: 100.5329664,
              latitude: 13.7562884,
              address: "128/328 ชั้น 30 อาคาร, พญาไท พลาซ่า ถนน พญาไท แขวง ทุ่งพญาไท เขตราชเทวี กรุงเทพมหานคร 10400, Thailand",
              directionLink: "https://maps.google.com/?cid=12855028772927348601",
              isOpenInfo: true,
          },
          ],
          branchMultipleID: [1],
          branchSinglePlaceID: "ChIJoYfRZsqe4jAReZ_CY488ZrI",
          branchSingleAddress: "128/328 ชั้น 30 อาคาร, พญาไท พลาซ่า ถนน พญาไท แขวง ทุ่งพญาไท เขตราชเทวี กรุงเทพมหานคร 10400, Thailand",
          center: { lat: 13.7562884, lng: 100.5329664 },
          mapTheme: 'default',

        },
      }
    }
  }
}

export {
  createWidgetMap
}
export default {
  createWidgetMap
}